import { ANALYTICS_DIDOMI_COOKIE } from '~~/modules/integrations/didomi/constants'

const ga4Service = {
  _didomiEventsLoaded: false,
  queue: new Proxy([], {
    set: (target: any, property: any, value) => {
      target[property] = value
      setTimeout(() => {
        ga4Service._processQueue()
      }, 1)
      return true
    },
  }),
  _processQueue() {
    const { $didomiService } = useNuxtApp()
    if (process.client && $didomiService.hasConsent(ANALYTICS_DIDOMI_COOKIE)) {
      while (this.queue.length) {
        const ev = this.queue.shift()
        window.dataLayer.push(ev)
      }
    } else {
      for (let i = 0; i < this.queue.length; i++) {
        const ev = this.queue[i]
        if (ev.eventCallback) {
          ev.eventCallback()
          ev.eventCallback = undefined
        }
      }
      // eslint-disable-next-line no-console
      console.log(
        'GA4 is not activated because Analytical cookies are not allowed',
      )
    }
  },
  send: (params: any) => {
    ga4Service._loadDidomiEvents()
    ga4Service.queue.push(params)
  },
  _loadDidomiEvents() {
    if (!process.client || ga4Service._didomiEventsLoaded) return
    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(() => {
      ga4Service._processQueue()
      window.Didomi.on('consent.changed', () => {
        ga4Service._processQueue()
      })
    })
    ga4Service._didomiEventsLoaded = true
  },
}
export default ga4Service
